import React from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/global.css'
import WhatsAppChat from '../components/WhatsAppChat'

const mount = () => {
  const container = document.getElementById('whatsapp-chat-root')
  if (container) {
    const props = JSON.parse(container.dataset.props || '{}')
    createRoot(container).render(<WhatsAppChat {...props} />)
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(mount, { timeout: 2000 })
} else {
  setTimeout(mount, 200)
}
